import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { CSSProperties, FC, ReactNode } from "react";
interface AnimatedShinyTextProps {
  children: ReactNode;
  className?: string;
  shimmerWidth?: number;
}
export const AnimatedShinyText: FC<AnimatedShinyTextProps> = t0 => {
  const $ = _c(8);
  const {
    children,
    className,
    shimmerWidth: t1
  } = t0;
  const shimmerWidth = t1 === undefined ? 150 : t1;
  const t2 = `${shimmerWidth}px`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      "--shiny-width": t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as CSSProperties;
  let t5;
  if ($[2] !== className) {
    t5 = clsx("mx-auto max-w-md text-white/60", "animate-shiny-text bg-clip-text bg-no-repeat animate-infinite [background-size:var(--shiny-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)]", "bg-gradient-to-r from-transparent via-white/80 via-50% to-transparent", className);
    $[2] = className;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== t4 || $[6] !== t5) {
    t6 = <p style={t4} className={t5}>{children}</p>;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};